import { t } from 'i18next';
import React from 'react';

import { iconType } from 'src/types';

const NoDataIcon: React.FC<iconType.PropsType & { stext?: string | null }> = ({
  style,
  color,
  onClick,
  className,
  stext,
}) => {
  return (
    <div
      className={className && className}
      role="button"
      onClick={onClick && onClick}
      onKeyDown={onClick && onClick}
      tabIndex={onClick && -1}
      style={onClick ? { cursor: 'pointer', display: 'inline-block' } : { display: 'inline-block' }}
    >
      <svg
        style={{ ...style, position: 'relative', direction: 'ltr' }}
        xmlns="http://www.w3.org/2000/svg"
        width="117.641"
        height="208.467"
        viewBox="0 0 117.641 208.467"
      >
        <text
          id="NO_DATA"
          data-name="NO DATA"
          transform="translate(18.585 21)"
          fill={color || '#e19477'}
          fontSize="19"
          fontFamily="SegoeUI-Bold, Segoe UI"
          fontWeight="700"
        >
          <tspan x="0" y="0">
            {stext === null && t('errors.noDataError')}
          </tspan>
        </text>
        <g id="NoData" transform="translate(0 84.807)" opacity="0.5">
          <path
            id="Path_37030"
            data-name="Path 37030"
            d="M643.8,519.635c.551-.268,1.093-.56,1.621-.875v.793a2.732,2.732,0,0,1-2.734,2.734,2.693,2.693,0,0,1-1.924-.8,2.637,2.637,0,0,1-.376-.463c.635-.2,1.259-.437,1.874-.694l.426.1A1.268,1.268,0,0,0,643.8,519.635Z"
            transform="translate(-540.65 -440.968)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37031"
            data-name="Path 37031"
            d="M666.184,509.33v5.314a.962.962,0,1,1-1.924,0v-3.807A23.4,23.4,0,0,0,666.184,509.33Z"
            transform="translate(-557.562 -434.287)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37032"
            data-name="Path 37032"
            d="M584.6,544.381a1.441,1.441,0,0,0,1.277-1.557v-1.848a1.748,1.748,0,0,0-.376-1.1,1.166,1.166,0,0,0-.9-.458,1.439,1.439,0,0,0-1.28,1.557v1.848a1.749,1.749,0,0,0,.376,1.1A1.148,1.148,0,0,0,584.6,544.381Zm2.731-4.081v3.23a2.728,2.728,0,0,1-4.664,1.924,2.693,2.693,0,0,1-.8-1.924v-3.242a2.731,2.731,0,0,1,5.46,0Z"
            transform="translate(-499.188 -454.349)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37033"
            data-name="Path 37033"
            d="M459.543,439.268a1.436,1.436,0,0,1-1.277,1.557,1.166,1.166,0,0,1-.9-.458,1.714,1.714,0,0,1-.373-1.1v-1.845a1.442,1.442,0,0,1,1.277-1.562,1.166,1.166,0,0,1,.9.458,1.726,1.726,0,0,1,.376,1.1Z"
            transform="translate(-410.711 -382.234)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37034"
            data-name="Path 37034"
            d="M306.222,481.511a2.687,2.687,0,0,1-.8-1.924V477.06a25.587,25.587,0,0,0,3.032,5.247,2.708,2.708,0,0,1-2.23-.784Z"
            transform="translate(-303.324 -411.424)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37035"
            data-name="Path 37035"
            d="M545.611,544.164a1.441,1.441,0,0,0,1.271-1.562v-1.842a1.749,1.749,0,0,0-.373-1.1,1.166,1.166,0,0,0-.9-.458,1.437,1.437,0,0,0-1.277,1.557V542.6a1.725,1.725,0,0,0,.376,1.1A1.166,1.166,0,0,0,545.611,544.164Zm2.726-.875a2.728,2.728,0,1,1-5.457,0v-3.224a2.728,2.728,0,0,1,5.457,0Z"
            transform="translate(-471.564 -454.132)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37036"
            data-name="Path 37036"
            d="M609.517,538.414v6.766a.965.965,0,0,1-1.927,0v-6.766a.965.965,0,0,1,1.927,0Z"
            transform="translate(-517.411 -454.247)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37037"
            data-name="Path 37037"
            d="M659.494,574.1v6.76a.962.962,0,0,1-1.924,0V574.1a.962.962,0,1,1,1.924,0Z"
            transform="translate(-552.822 -479.496)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37038"
            data-name="Path 37038"
            d="M510.653,473.3v1.842a1.442,1.442,0,0,1-1.277,1.562,1.166,1.166,0,0,1-.9-.458,1.749,1.749,0,0,1-.373-1.1V473.3a1.436,1.436,0,0,1,1.277-1.557,1.166,1.166,0,0,1,.9.452,1.749,1.749,0,0,1,.376,1.1Z"
            transform="translate(-446.922 -407.655)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37039"
            data-name="Path 37039"
            d="M686.824,481.434a2.734,2.734,0,0,1-2.714,2.734,25.513,25.513,0,0,0,2.714-4.518Z"
            transform="translate(-571.625 -413.259)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37040"
            data-name="Path 37040"
            d="M357.044,574.062v6.76a.962.962,0,1,1-1.924,0v-6.76a.962.962,0,0,1,1.924,0Z"
            transform="translate(-338.537 -479.468)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37041"
            data-name="Path 37041"
            d="M530.658,538.319v6.76a.959.959,0,0,1-1.918,0v-6.76a.959.959,0,1,1,1.918,0Z"
            transform="translate(-461.546 -454.146)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37042"
            data-name="Path 37042"
            d="M425.977,538.374v6.766a.965.965,0,0,1-1.927,0v-6.766a.965.965,0,0,1,1.927,0Z"
            transform="translate(-387.374 -454.218)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37043"
            data-name="Path 37043"
            d="M510.187,406.528a1.749,1.749,0,0,1,.376,1.1v1.842a1.447,1.447,0,0,1-1.277,1.557,1.166,1.166,0,0,1-.9-.458,1.749,1.749,0,0,1-.373-1.1v-1.842a1.442,1.442,0,0,1,1.277-1.562,1.166,1.166,0,0,1,.9.458Z"
            transform="translate(-446.859 -361.128)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37044"
            data-name="Path 37044"
            d="M626.632,529.15a.944.944,0,0,1-.837.5.962.962,0,0,1-.635-.248C625.656,529.334,626.145,529.252,626.632,529.15Z"
            transform="translate(-529.859 -448.329)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37045"
            data-name="Path 37045"
            d="M310.814,501.962v6.76a.962.962,0,0,1-1.924,0v-6.76a.962.962,0,0,1,1.924,0Z"
            transform="translate(-305.783 -428.385)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37046"
            data-name="Path 37046"
            d="M657.237,439.315a1.43,1.43,0,0,1-1.271,1.562,1.146,1.146,0,0,1-.9-.458,1.749,1.749,0,0,1-.376-1.1v-1.842a1.442,1.442,0,0,1,1.277-1.562,1.166,1.166,0,0,1,.9.458,1.772,1.772,0,0,1,.367,1.1Z"
            transform="translate(-550.781 -382.269)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37047"
            data-name="Path 37047"
            d="M604.173,509v1.848A1.447,1.447,0,0,1,602.9,512.4a1.166,1.166,0,0,1-.9-.458,1.711,1.711,0,0,1-.376-1.1V509a1.447,1.447,0,0,1,1.277-1.557,1.166,1.166,0,0,1,.9.458A1.714,1.714,0,0,1,604.173,509Z"
            transform="translate(-513.181 -432.948)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37048"
            data-name="Path 37048"
            d="M435.591,579.92a1.438,1.438,0,0,0,1.271-1.565v-1.842a1.749,1.749,0,0,0-.367-1.1,1.192,1.192,0,0,0-.9-.458,1.441,1.441,0,0,0-1.277,1.562v1.842a1.717,1.717,0,0,0,.376,1.108A1.166,1.166,0,0,0,435.591,579.92Zm2.726-4.1v3.227a2.728,2.728,0,0,1-5.457,0v-3.227a2.729,2.729,0,0,1,2.731-2.731,2.7,2.7,0,0,1,1.927.8A2.729,2.729,0,0,1,438.317,575.821Z"
            transform="translate(-393.615 -479.461)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37049"
            data-name="Path 37049"
            d="M507.014,540.765a1.748,1.748,0,0,0-.376-1.1,1.166,1.166,0,0,0-.9-.458,1.439,1.439,0,0,0-1.277,1.563v1.842a1.775,1.775,0,0,0,.373,1.1,1.166,1.166,0,0,0,.9.452,1.436,1.436,0,0,0,1.277-1.557Zm.647-2.624a2.717,2.717,0,0,1,.8,1.93v3.23a2.729,2.729,0,0,1-4.664,1.924,2.69,2.69,0,0,1-.8-1.924v-3.23a2.734,2.734,0,0,1,2.731-2.731,2.7,2.7,0,0,1,1.933.8Z"
            transform="translate(-443.309 -454.132)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37050"
            data-name="Path 37050"
            d="M682.7,502.009v6.769a.959.959,0,1,1-1.918,0v-6.769a.959.959,0,0,1,1.918,0Z"
            transform="translate(-569.266 -428.421)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37051"
            data-name="Path 37051"
            d="M600.569,614.117v-1.848a1.714,1.714,0,0,0-.373-1.1,1.166,1.166,0,0,0-.9-.458,1.439,1.439,0,0,0-1.277,1.557v1.848a1.711,1.711,0,0,0,.376,1.1,1.166,1.166,0,0,0,.9.458A1.439,1.439,0,0,0,600.569,614.117Zm1.457.694a2.728,2.728,0,0,1-5.457,0v-3.23a2.728,2.728,0,1,1,5.457,0Z"
            transform="translate(-509.603 -504.797)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37052"
            data-name="Path 37052"
            d="M646.468,509v1.842a1.92,1.92,0,0,1-.163.776c-.5.247-1.017.483-1.539.69l-.469-.361a1.766,1.766,0,0,1-.376-1.1V509a1.447,1.447,0,0,1,1.271-1.557,1.166,1.166,0,0,1,.9.458A1.714,1.714,0,0,1,646.468,509Z"
            transform="translate(-543.151 -432.948)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37053"
            data-name="Path 37053"
            d="M411.814,538.252v6.76a.962.962,0,1,1-1.924,0v-6.76a.962.962,0,1,1,1.924,0Z"
            transform="translate(-377.341 -454.097)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37054"
            data-name="Path 37054"
            d="M483.267,440.824a1.166,1.166,0,0,1-.9-.458,1.749,1.749,0,0,1-.373-1.1v-1.845a1.442,1.442,0,0,1,1.277-1.562,1.146,1.146,0,0,1,.9.458,1.749,1.749,0,0,1,.376,1.1v1.845A1.435,1.435,0,0,1,483.267,440.824Z"
            transform="translate(-428.424 -382.234)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37055"
            data-name="Path 37055"
            d="M309.349,542.575v-1.857a1.711,1.711,0,0,0-.376-1.1,1.166,1.166,0,0,0-.9-.458,1.441,1.441,0,0,0-1.28,1.557v1.851a1.7,1.7,0,0,0,.376,1.1,1.166,1.166,0,0,0,.9.458A1.432,1.432,0,0,0,309.349,542.575Zm1.457-2.536v3.227a2.728,2.728,0,0,1-5.457,0v-3.227a2.728,2.728,0,0,1,5.457,0Z"
            transform="translate(-303.275 -454.111)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37056"
            data-name="Path 37056"
            d="M468.394,609.762v6.76a.962.962,0,1,1-1.924,0v-6.76a.962.962,0,1,1,1.924,0Z"
            transform="translate(-417.428 -504.761)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37057"
            data-name="Path 37057"
            d="M608.781,472.192a1.726,1.726,0,0,1,.376,1.1v1.842a1.442,1.442,0,0,1-1.271,1.562,1.166,1.166,0,0,1-.9-.458,1.748,1.748,0,0,1-.376-1.1V473.3a1.436,1.436,0,0,1,1.277-1.557A1.166,1.166,0,0,1,608.781,472.192Z"
            transform="translate(-516.716 -407.655)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37058"
            data-name="Path 37058"
            d="M407.448,647.279v6.76a.959.959,0,1,1-1.918,0v-6.76a.959.959,0,0,1,1.918,0Z"
            transform="translate(-374.252 -531.344)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37059"
            data-name="Path 37059"
            d="M448.793,508.935v1.842a1.442,1.442,0,0,1-1.277,1.562,1.165,1.165,0,0,1-.9-.458,1.714,1.714,0,0,1-.376-1.1v-1.842a1.445,1.445,0,0,1,1.277-1.565,1.184,1.184,0,0,1,.9.458A1.732,1.732,0,0,1,448.793,508.935Z"
            transform="translate(-403.094 -432.898)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37060"
            data-name="Path 37060"
            d="M652.361,544.155a1.441,1.441,0,0,0,1.271-1.562V540.75a1.725,1.725,0,0,0-.373-1.1,1.166,1.166,0,0,0-.9-.458,1.439,1.439,0,0,0-1.277,1.557v1.842a1.778,1.778,0,0,0,.376,1.1A1.146,1.146,0,0,0,652.361,544.155Zm2.726-.875a2.728,2.728,0,0,1-5.457,0v-3.224a2.728,2.728,0,0,1,4.664-1.924,2.7,2.7,0,0,1,.8,1.924Z"
            transform="translate(-547.196 -454.123)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37061"
            data-name="Path 37061"
            d="M351.53,435.86a1.145,1.145,0,0,1,.9.458,1.749,1.749,0,0,1,.376,1.1v1.845a1.436,1.436,0,0,1-1.277,1.557,1.166,1.166,0,0,1-.9-.458,1.749,1.749,0,0,1-.376-1.1v-1.845A1.443,1.443,0,0,1,351.53,435.86Z"
            transform="translate(-335.086 -382.234)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37062"
            data-name="Path 37062"
            d="M570.5,538.292v6.76a.962.962,0,0,1-1.924,0v-6.76a.962.962,0,0,1,1.924,0Z"
            transform="translate(-489.773 -454.125)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37063"
            data-name="Path 37063"
            d="M461.783,573.926v6.76a.965.965,0,1,1-1.927,0v-6.76a.965.965,0,1,1,1.927,0Z"
            transform="translate(-412.741 -479.332)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37064"
            data-name="Path 37064"
            d="M484.167,472.106a1.749,1.749,0,0,1,.376,1.1v1.842a1.445,1.445,0,0,1-1.277,1.565,1.166,1.166,0,0,1-.9-.458,1.766,1.766,0,0,1-.373-1.108V473.2a1.442,1.442,0,0,1,1.277-1.562A1.166,1.166,0,0,1,484.167,472.106Z"
            transform="translate(-428.423 -407.584)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37065"
            data-name="Path 37065"
            d="M344.873,520.1v1.458a.965.965,0,1,1-1.927,0V519.1C343.57,519.461,344.212,519.8,344.873,520.1Z"
            transform="translate(-329.911 -441.209)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37066"
            data-name="Path 37066"
            d="M479.656,537.28a2.731,2.731,0,0,1,2.731,2.731v3.227a2.734,2.734,0,0,1-2.731,2.731,2.693,2.693,0,0,1-1.924-.8,2.734,2.734,0,0,1-.8-1.933v-3.227A2.729,2.729,0,0,1,479.656,537.28Zm1.277,3.416a1.749,1.749,0,0,0-.376-1.1,1.146,1.146,0,0,0-.9-.458,1.441,1.441,0,0,0-1.277,1.563v1.842a1.778,1.778,0,0,0,.373,1.108,1.166,1.166,0,0,0,.9.458,1.442,1.442,0,0,0,1.277-1.565Z"
            transform="translate(-424.839 -454.09)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37067"
            data-name="Path 37067"
            d="M554.744,574.1v6.76a.962.962,0,0,1-1.924,0V574.1a.962.962,0,1,1,1.924,0Z"
            transform="translate(-478.607 -479.496)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37068"
            data-name="Path 37068"
            d="M366.036,508.957V510.8a1.442,1.442,0,0,1-1.277,1.562,1.183,1.183,0,0,1-.9-.458,1.714,1.714,0,0,1-.376-1.1v-1.842a1.436,1.436,0,0,1,1.28-1.557,1.166,1.166,0,0,1,.9.449A1.728,1.728,0,0,1,366.036,508.957Z"
            transform="translate(-344.459 -432.92)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37069"
            data-name="Path 37069"
            d="M428.173,609.884v6.76a.965.965,0,1,1-1.927,0v-6.76a.965.965,0,0,1,1.927,0Z"
            transform="translate(-388.929 -504.883)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37070"
            data-name="Path 37070"
            d="M406.561,579.934a1.442,1.442,0,0,0,1.277-1.565v-1.842a1.726,1.726,0,0,0-.376-1.1,1.166,1.166,0,0,0-.9-.452,1.435,1.435,0,0,0-1.277,1.557v1.842a1.731,1.731,0,0,0,.373,1.108A1.183,1.183,0,0,0,406.561,579.934Zm2.726-.875a2.728,2.728,0,1,1-5.457,0v-3.224a2.728,2.728,0,0,1,5.457,0Z"
            transform="translate(-373.048 -479.475)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37071"
            data-name="Path 37071"
            d="M638.543,538.414v6.76a.965.965,0,1,1-1.927,0v-6.76a.965.965,0,0,1,1.927,0Z"
            transform="translate(-537.975 -454.247)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37072"
            data-name="Path 37072"
            d="M347.008,543.652a1.166,1.166,0,0,0,.9.458,1.442,1.442,0,0,0,1.277-1.565V540.7a1.749,1.749,0,0,0-.376-1.1,1.146,1.146,0,0,0-.9-.458,1.441,1.441,0,0,0-1.277,1.563v1.842A1.778,1.778,0,0,0,347.008,543.652Zm3.629-3.641v3.227a2.728,2.728,0,1,1-5.457,0v-3.227a2.734,2.734,0,0,1,2.731-2.731,2.7,2.7,0,0,1,1.924.8A2.734,2.734,0,0,1,350.637,540.011Z"
            transform="translate(-331.494 -454.09)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37073"
            data-name="Path 37073"
            d="M505.751,579.974a1.441,1.441,0,0,0,1.277-1.562v-1.842a1.731,1.731,0,0,0-.376-1.1,1.146,1.146,0,0,0-.9-.458,1.437,1.437,0,0,0-1.277,1.557v1.842a1.749,1.749,0,0,0,.373,1.1A1.166,1.166,0,0,0,505.751,579.974Zm2.726-.875a2.728,2.728,0,0,1-5.457,0v-3.224a2.728,2.728,0,0,1,5.457,0Z"
            transform="translate(-443.323 -479.503)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37074"
            data-name="Path 37074"
            d="M573.554,647.272v6.76a.962.962,0,1,1-1.924,0v-6.76a.962.962,0,0,1,1.924,0Z"
            transform="translate(-491.933 -531.337)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37075"
            data-name="Path 37075"
            d="M402.869,612.219a1.731,1.731,0,0,0-.376-1.1,1.145,1.145,0,0,0-.9-.458,1.439,1.439,0,0,0-1.277,1.557v1.842a1.767,1.767,0,0,0,.373,1.108,1.166,1.166,0,0,0,.9.458,1.442,1.442,0,0,0,1.277-1.565Zm1.458,2.536a2.728,2.728,0,0,1-5.457,0v-3.227a2.728,2.728,0,1,1,5.457,0Z"
            transform="translate(-369.534 -504.761)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37076"
            data-name="Path 37076"
            d="M312.943,475.054a1.436,1.436,0,0,1-1.277,1.557,1.166,1.166,0,0,1-.9-.449,1.728,1.728,0,0,1-.376-1.108V473.2a1.442,1.442,0,0,1,1.277-1.562,1.184,1.184,0,0,1,.9.458,1.729,1.729,0,0,1,.373,1.1Z"
            transform="translate(-306.845 -407.584)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37077"
            data-name="Path 37077"
            d="M391.1,573.926v6.76a.965.965,0,1,1-1.927,0v-6.76a.965.965,0,1,1,1.927,0Z"
            transform="translate(-362.665 -479.332)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37078"
            data-name="Path 37078"
            d="M361.156,615.627a1.442,1.442,0,0,0,1.277-1.565v-1.842a1.7,1.7,0,0,0-.376-1.1,1.166,1.166,0,0,0-.9-.458,1.439,1.439,0,0,0-1.277,1.557v1.842a1.731,1.731,0,0,0,.373,1.108A1.184,1.184,0,0,0,361.156,615.627Zm2.731-4.1v3.227a2.728,2.728,0,1,1-5.457,0v-3.227a2.728,2.728,0,1,1,5.457,0Z"
            transform="translate(-340.882 -504.761)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37079"
            data-name="Path 37079"
            d="M638.187,473.282v1.842a1.442,1.442,0,0,1-1.277,1.562,1.166,1.166,0,0,1-.895-.458,1.749,1.749,0,0,1-.376-1.1v-1.842a1.442,1.442,0,0,1,1.271-1.562,1.184,1.184,0,0,1,.9.458A1.723,1.723,0,0,1,638.187,473.282Z"
            transform="translate(-537.284 -407.64)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37080"
            data-name="Path 37080"
            d="M411.087,472.106a1.714,1.714,0,0,1,.376,1.1v1.842a1.445,1.445,0,0,1-1.277,1.565,1.183,1.183,0,0,1-.9-.458,1.732,1.732,0,0,1-.373-1.108V473.2a1.442,1.442,0,0,1,1.277-1.562A1.166,1.166,0,0,1,411.087,472.106Z"
            transform="translate(-376.646 -407.584)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37081"
            data-name="Path 37081"
            d="M563.793,509v1.848a1.447,1.447,0,0,1-1.277,1.557,1.166,1.166,0,0,1-.9-.458,1.749,1.749,0,0,1-.376-1.1V509a1.447,1.447,0,0,1,1.277-1.557,1.166,1.166,0,0,1,.9.458A1.749,1.749,0,0,1,563.793,509Z"
            transform="translate(-484.572 -432.948)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37082"
            data-name="Path 37082"
            d="M584.564,609.8v6.769a.962.962,0,0,1-1.924,0V609.8a.962.962,0,0,1,1.924,0Z"
            transform="translate(-499.734 -504.79)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37083"
            data-name="Path 37083"
            d="M682.243,473.3v1.842a1.442,1.442,0,0,1-1.277,1.562,1.166,1.166,0,0,1-.9-.458,1.714,1.714,0,0,1-.376-1.1V473.3a1.436,1.436,0,0,1,1.277-1.557,1.166,1.166,0,0,1,.9.452,1.749,1.749,0,0,1,.373,1.1Z"
            transform="translate(-568.493 -407.655)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37084"
            data-name="Path 37084"
            d="M677.361,573.15a2.731,2.731,0,0,1,2.726,2.726V579.1a2.728,2.728,0,1,1-5.457,0v-3.227A2.728,2.728,0,0,1,677.361,573.15Zm0,1.863a1.437,1.437,0,0,0-1.277,1.557v1.848a1.711,1.711,0,0,0,.376,1.1,1.166,1.166,0,0,0,.9.458,1.441,1.441,0,0,0,1.28-1.557v-1.848a1.7,1.7,0,0,0-.376-1.1A1.166,1.166,0,0,0,677.361,575.013Z"
            transform="translate(-564.909 -479.503)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37085"
            data-name="Path 37085"
            d="M326.594,506.913v4.778a.962.962,0,1,1-1.924,0v-6.5A22.908,22.908,0,0,0,326.594,506.913Z"
            transform="translate(-316.963 -431.354)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37086"
            data-name="Path 37086"
            d="M386.853,609.884v6.76a.965.965,0,1,1-1.927,0v-6.76a.965.965,0,0,1,1.927,0Z"
            transform="translate(-359.654 -504.883)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37087"
            data-name="Path 37087"
            d="M588.783,574.224v6.76a.965.965,0,1,1-1.927,0v-6.76a.965.965,0,0,1,1.927,0Z"
            transform="translate(-502.72 -479.618)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37088"
            data-name="Path 37088"
            d="M440.4,409.475a1.435,1.435,0,0,1-1.271,1.557,1.166,1.166,0,0,1-.9-.458,1.7,1.7,0,0,1-.376-1.1v-1.842a1.442,1.442,0,0,1,1.277-1.562,1.192,1.192,0,0,1,.9.458,1.749,1.749,0,0,1,.367,1.1Z"
            transform="translate(-397.15 -361.128)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37089"
            data-name="Path 37089"
            d="M360.11,526.66a24.6,24.6,0,0,0,3.583.875,2.726,2.726,0,0,1-3.247-.458A2.838,2.838,0,0,1,360.11,526.66Z"
            transform="translate(-342.072 -446.565)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37090"
            data-name="Path 37090"
            d="M523.981,652.89a1.166,1.166,0,0,0,.895.458,1.439,1.439,0,0,0,1.277-1.557v-1.863a1.709,1.709,0,0,0-.373-1.1,1.184,1.184,0,0,0-.9-.458,1.439,1.439,0,0,0-1.268,1.557v1.851A1.749,1.749,0,0,0,523.981,652.89Zm3.629-.414a2.729,2.729,0,0,1-2.734,2.731,2.691,2.691,0,0,1-1.924-.8,2.723,2.723,0,0,1-.8-1.933v-3.227a2.731,2.731,0,0,1,5.46,0Z"
            transform="translate(-456.877 -531.547)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37091"
            data-name="Path 37091"
            d="M482.387,579.046a2.734,2.734,0,0,1-2.731,2.731,2.694,2.694,0,0,1-1.924-.8,2.723,2.723,0,0,1-.8-1.933v-3.227a2.728,2.728,0,0,1,4.664-1.927,2.694,2.694,0,0,1,.8,1.927Zm-1.457-2.536a1.749,1.749,0,0,0-.376-1.1,1.166,1.166,0,0,0-.9-.452,1.435,1.435,0,0,0-1.277,1.557v1.842a1.766,1.766,0,0,0,.373,1.108,1.166,1.166,0,0,0,.9.458,1.442,1.442,0,0,0,1.277-1.565Z"
            transform="translate(-424.839 -479.459)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37092"
            data-name="Path 37092"
            d="M666.1,609.924v6.769a.965.965,0,0,1-1.927,0v-6.769a.965.965,0,0,1,1.927,0Z"
            transform="translate(-557.498 -504.911)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37093"
            data-name="Path 37093"
            d="M678.245,539.66a1.184,1.184,0,0,0-.9-.458,1.437,1.437,0,0,0-1.277,1.557V542.6a1.726,1.726,0,0,0,.376,1.1,1.166,1.166,0,0,0,.9.458,1.443,1.443,0,0,0,1.28-1.562v-1.842A1.711,1.711,0,0,0,678.245,539.66Zm-3.635.405a2.728,2.728,0,0,1,5.457,0v3.227a2.728,2.728,0,0,1-5.457,0Z"
            transform="translate(-564.894 -454.132)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37094"
            data-name="Path 37094"
            d="M570.5,574.1v6.76a.962.962,0,0,1-1.924,0V574.1a.962.962,0,1,1,1.924,0Z"
            transform="translate(-489.773 -479.496)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37095"
            data-name="Path 37095"
            d="M332.957,538.374v6.766a.965.965,0,0,1-1.927,0v-6.766a.965.965,0,0,1,1.927,0Z"
            transform="translate(-321.469 -454.219)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37096"
            data-name="Path 37096"
            d="M454.641,544.11a1.442,1.442,0,0,0,1.277-1.565V540.7a1.749,1.749,0,0,0-.373-1.1,1.166,1.166,0,0,0-.9-.458,1.441,1.441,0,0,0-1.277,1.562v1.842a1.729,1.729,0,0,0,.376,1.108A1.166,1.166,0,0,0,454.641,544.11Zm2.726-4.1v3.227a2.728,2.728,0,1,1-5.457,0v-3.227a2.734,2.734,0,0,1,2.731-2.731,2.685,2.685,0,0,1,1.924.8A2.734,2.734,0,0,1,457.367,540.011Z"
            transform="translate(-407.112 -454.089)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37097"
            data-name="Path 37097"
            d="M625.884,609.8v6.769a.962.962,0,1,1-1.924,0V609.8a.962.962,0,0,1,1.924,0Z"
            transform="translate(-529.009 -504.79)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37098"
            data-name="Path 37098"
            d="M389.647,543.245a2.728,2.728,0,0,1-5.457,0v-3.227a2.728,2.728,0,0,1,5.457,0Zm-1.822-3.635a1.167,1.167,0,0,0-.9-.458,1.439,1.439,0,0,0-1.277,1.557v1.842a1.749,1.749,0,0,0,.376,1.108,1.146,1.146,0,0,0,.9.458,1.442,1.442,0,0,0,1.277-1.565V540.7A1.749,1.749,0,0,0,387.825,539.61Z"
            transform="translate(-359.133 -454.097)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37099"
            data-name="Path 37099"
            d="M372.818,538.259v6.76a.959.959,0,0,1-1.918,0v-6.76a.959.959,0,1,1,1.918,0Z"
            transform="translate(-349.717 -454.104)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37100"
            data-name="Path 37100"
            d="M406.466,510.8a1.442,1.442,0,0,1-1.277,1.562,1.166,1.166,0,0,1-.9-.458,1.766,1.766,0,0,1-.376-1.1v-1.842a1.436,1.436,0,0,1,1.28-1.557,1.166,1.166,0,0,1,.9.449,1.749,1.749,0,0,1,.376,1.108Z"
            transform="translate(-373.104 -432.92)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37101"
            data-name="Path 37101"
            d="M312.943,437.437v1.851a1.447,1.447,0,0,1-1.277,1.557,1.166,1.166,0,0,1-.9-.458,1.7,1.7,0,0,1-.376-1.1v-1.851a1.447,1.447,0,0,1,1.277-1.557,1.192,1.192,0,0,1,.9.458A1.726,1.726,0,0,1,312.943,437.437Z"
            transform="translate(-306.845 -382.248)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37102"
            data-name="Path 37102"
            d="M484.914,609.762v6.76a.962.962,0,0,1-1.924,0v-6.76a.962.962,0,0,1,1.924,0Z"
            transform="translate(-429.132 -504.761)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37103"
            data-name="Path 37103"
            d="M588.24,435.93a1.166,1.166,0,0,1,.9.458,1.749,1.749,0,0,1,.373,1.1v1.842a1.442,1.442,0,0,1-1.277,1.562,1.143,1.143,0,0,1-.895-.458,1.726,1.726,0,0,1-.376-1.1v-1.842A1.445,1.445,0,0,1,588.24,435.93Z"
            transform="translate(-502.801 -382.283)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37104"
            data-name="Path 37104"
            d="M440.493,473.2v1.842a1.436,1.436,0,0,1-1.277,1.557,1.166,1.166,0,0,1-.9-.449,1.749,1.749,0,0,1-.373-1.108V473.2a1.442,1.442,0,0,1,1.277-1.562,1.166,1.166,0,0,1,.9.458A1.714,1.714,0,0,1,440.493,473.2Z"
            transform="translate(-397.214 -407.584)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37105"
            data-name="Path 37105"
            d="M336.373,473.2v1.842A1.436,1.436,0,0,1,335.1,476.6a1.166,1.166,0,0,1-.9-.449,1.749,1.749,0,0,1-.376-1.108V473.2a1.442,1.442,0,0,1,1.277-1.562,1.166,1.166,0,0,1,.9.458,1.749,1.749,0,0,1,.373,1.1Z"
            transform="translate(-323.445 -407.584)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37106"
            data-name="Path 37106"
            d="M303.052,312.352a2.729,2.729,0,0,0,2.731-2.731v-3.227a2.728,2.728,0,0,0-5.457,0v3.227a2.722,2.722,0,0,0,.8,1.933A2.69,2.69,0,0,0,303.052,312.352Zm5.725,0a.965.965,0,0,0,.965-.965v-6.76a.962.962,0,0,0-1.924,0v6.766a.962.962,0,0,0,.959.959Zm-1.627,7.707a2.688,2.688,0,0,0,.8,1.924,2.726,2.726,0,0,0,4.664-1.924v-3.227a2.728,2.728,0,1,0-5.457,0Zm60.356-5.941a2.725,2.725,0,0,0-2.723,2.726v3.227a2.728,2.728,0,0,0,5.457,0v-3.227a2.737,2.737,0,0,0-2.734-2.726Zm-6.821,8.687a2.731,2.731,0,0,0,2.726-2.734v-3.227a2.728,2.728,0,0,0-5.457,0v3.227a2.731,2.731,0,0,0,2.731,2.734Zm2.7-25.1a2.728,2.728,0,0,0-5.457,0v3.23a2.69,2.69,0,0,0,.8,1.924,2.728,2.728,0,0,0,4.664-1.924Zm-46.62,17.359a.965.965,0,1,0-1.927,0v6.76a.965.965,0,0,0,1.927,0Zm49.643-2.7a.959.959,0,0,0,.962-.959v-6.769a.962.962,0,0,0-1.921,0v6.769A.959.959,0,0,0,366.408,312.367Zm-49-5.973a2.728,2.728,0,0,0-5.457,0v3.227a2.728,2.728,0,0,0,5.457,0Zm3.959,8.672a.965.965,0,1,0-1.927,0v6.76a.965.965,0,0,0,1.927,0Zm4.373-.965a.962.962,0,0,0-.959.965v6.76a.962.962,0,0,0,1.924,0v-6.76a.965.965,0,0,0-.971-.965Zm-2.21,18.132a.962.962,0,0,0,1.924,0v-6.76a.962.962,0,0,0-1.924,0Zm54.511-19.866a.965.965,0,0,0,.959-.968v-6.76a.962.962,0,1,0-1.924,0v6.754a.968.968,0,0,0,.965.974Zm.959,2.711a.962.962,0,1,0-1.924,0v6.76a.962.962,0,1,0,1.924,0Zm-45.3-.187a2.691,2.691,0,0,0-1.924-.8,2.734,2.734,0,0,0-2.734,2.731v3.227a2.688,2.688,0,0,0,.8,1.924,2.729,2.729,0,0,0,4.664-1.924v-3.218a2.717,2.717,0,0,0-.807-1.941Zm48.051-3.335a2.726,2.726,0,0,0,4.664-1.933v-3.218a2.728,2.728,0,1,0-5.457,0v3.239a2.717,2.717,0,0,0,.793,1.921Zm1.612,2.554a.953.953,0,0,0-.959.959v6.76a.962.962,0,1,0,1.921,0v-6.751a.956.956,0,0,0-.962-.959Zm-53.054,19.079a2.734,2.734,0,0,0,2.731-2.731v-3.218a2.7,2.7,0,0,0-.8-1.927,2.728,2.728,0,0,0-4.664,1.927v3.227A2.726,2.726,0,0,0,330.3,333.2Zm6.224,0a.965.965,0,0,0,.962-.965v-6.751a.965.965,0,1,0-1.927,0v6.76a.965.965,0,0,0,.977.965Zm-1.595-21.8a.962.962,0,1,0,1.924,0v-6.766a.962.962,0,1,0-1.924,0Zm54.779-15.45v6.76a.962.962,0,1,0,1.924,0v-6.76a.962.962,0,1,0-1.924,0Zm1.615,18.977a2.728,2.728,0,0,0-4.664,1.924v3.227a2.728,2.728,0,0,0,5.457,0v-3.227A2.691,2.691,0,0,0,391.328,314.92Zm-51.121-11.258a2.726,2.726,0,0,0,2.726-2.726v-3.23a2.728,2.728,0,0,0-5.457,0v3.23a2.731,2.731,0,0,0,2.731,2.726Zm2.44,29.535a2.728,2.728,0,0,0,2.726-2.731v-3.227a2.723,2.723,0,0,0-.8-1.933,2.685,2.685,0,0,0-1.924-.8,2.728,2.728,0,0,0-2.731,2.731v3.227a2.726,2.726,0,0,0,2.731,2.731Zm55.211-19.085a2.731,2.731,0,0,0-2.726,2.731v3.227a2.728,2.728,0,0,0,5.457,0v-3.227A2.731,2.731,0,0,0,397.858,314.113Zm-49.34-4.492v-3.227a2.731,2.731,0,1,0-5.463,0v3.227a2.731,2.731,0,0,0,5.463,0Zm49.34,2.746a.968.968,0,0,0,.965-.968v-6.76a.962.962,0,1,0-1.924,0v6.754a.965.965,0,0,0,.959.974ZM348.265,333.2a.962.962,0,0,0,.959-.965v-6.76a.965.965,0,0,0-1.927,0v6.76a.968.968,0,0,0,.968.965Zm-.968-11.369v-6.763a.962.962,0,0,0-1.924,0v6.76a.962.962,0,1,0,1.924,0Zm5.778,2.682a.959.959,0,0,0-.959.959v6.76a.962.962,0,0,0,1.924,0v-6.757a.959.959,0,0,0-.965-.962Zm51.856-9.436a.962.962,0,1,0-1.924,0v6.76a.962.962,0,1,0,1.924,0Zm-51.856-2.731a2.731,2.731,0,0,0,2.731-2.726v-3.224a2.728,2.728,0,0,0-5.457,0v3.227a2.731,2.731,0,0,0,2.726,2.726Zm1.933,2.548a2.728,2.728,0,0,0-4.664,1.933v3.227a2.728,2.728,0,0,0,5.457,0v-3.218a2.717,2.717,0,0,0-.793-1.941Zm50.34-10.424a2.728,2.728,0,0,0-4.664,1.93v3.247a2.728,2.728,0,0,0,5.457,0v-3.239a2.722,2.722,0,0,0-.8-1.93Zm-15.383-23.075a25.912,25.912,0,0,1,23.469,36.887v-1.434a2.728,2.728,0,0,0-5.457,0v3.227a2.737,2.737,0,0,0,2.731,2.734h0a25.834,25.834,0,0,1-3.862,4.133v-1.457a.962.962,0,1,0-1.924,0v2.965c-.624.446-1.265.857-1.924,1.239v-2.434a2.73,2.73,0,0,0-5.46,0v3.227a2.769,2.769,0,0,0,.426,1.458,24.613,24.613,0,0,1-2.967.77.9.9,0,0,0,.128-.472v-6.748a.962.962,0,0,0-1.924,0v6.76a.956.956,0,0,0,.324.72,25.714,25.714,0,0,1-3.571.248h-2.006a2.728,2.728,0,0,0,2.726-2.734v-3.227a2.728,2.728,0,0,0-5.457,0v3.227a2.737,2.737,0,0,0,2.731,2.734h-5.83a.968.968,0,0,0,.968-.968v-6.76a.965.965,0,0,0-1.927,0v6.76a.968.968,0,0,0,.959.968h-5.955a2.728,2.728,0,0,0,2.726-2.734v-3.227a2.728,2.728,0,0,0-5.457,0v3.227a2.705,2.705,0,0,0,.8,1.933,2.734,2.734,0,0,0,1.933.8h-6.288a.968.968,0,0,0,.965-.968v-6.76a.962.962,0,0,0-1.924,0v6.76a.965.965,0,0,0,.959.968h-5.346a.962.962,0,0,0,.959-.968v-6.76a.959.959,0,0,0-1.918,0v6.76a.965.965,0,0,0,.959.968h-4.6a.968.968,0,0,0,.968-.968v-6.76a.965.965,0,0,0-1.927,0v6.76a.965.965,0,0,0,.959.968H324.134a25.881,25.881,0,0,1-4.282-.356,2.731,2.731,0,0,0,1.411-2.39v-3.227a2.728,2.728,0,0,0-5.457,0v3.227a2.7,2.7,0,0,0,.464,1.525,24.535,24.535,0,0,1-3.075-1.2v-5.317a.965.965,0,1,0-1.927,0v4.314a25.554,25.554,0,0,1-3.4-2.332v-1.982a.962.962,0,0,0-1.924,0v.259a24.081,24.081,0,0,1-2.58-2.97,2.728,2.728,0,0,0,2.425-2.708v-3.221a2.728,2.728,0,1,0-5.457,0v.682a25.915,25.915,0,0,1,23.807-36.123c.621,0,1.233.032,1.848.076a31.106,31.106,0,0,1,62.137,0c.609-.035,1.218-.067,1.842-.067ZM374.4,321.829v-6.751a.962.962,0,1,0-1.924,0v6.76a.962.962,0,0,0,1.924,0Zm-31.436-1.778v-3.218a2.728,2.728,0,1,0-5.457,0v3.227a2.727,2.727,0,0,0,5.454,0Z"
            transform="translate(-298.231 -251.896)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37107"
            data-name="Path 37107"
            d="M534.056,473.3v1.842a1.442,1.442,0,0,1-1.28,1.562,1.166,1.166,0,0,1-.9-.458,1.767,1.767,0,0,1-.376-1.1V473.3a1.436,1.436,0,0,1,1.277-1.557,1.166,1.166,0,0,1,.9.452A1.778,1.778,0,0,1,534.056,473.3Z"
            transform="translate(-463.501 -407.655)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37108"
            data-name="Path 37108"
            d="M372.818,574.069v6.76a.959.959,0,0,1-1.918,0v-6.76a.959.959,0,0,1,1.918,0Z"
            transform="translate(-349.717 -479.475)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37109"
            data-name="Path 37109"
            d="M440.844,538.252v6.76a.962.962,0,1,1-1.924,0v-6.76a.962.962,0,1,1,1.924,0Z"
            transform="translate(-397.909 -454.097)"
            fill={color || '#e19477'}
          />
          <path
            id="Path_37110"
            data-name="Path 37110"
            d="M623.678,538.319v6.76a.959.959,0,0,1-1.918,0v-6.76a.959.959,0,1,1,1.918,0Z"
            transform="translate(-527.45 -454.146)"
            fill={color || '#e19477'}
          />
        </g>
      </svg>
    </div>
  );
};

NoDataIcon.defaultProps = {
  // style: { width: '18px', height: '18px', marginRight: '8px' },
  // color: 'white',
  stext: null,
  onClick: undefined,
  className: undefined,
};

export default NoDataIcon;
